// Configuração central da navegação. Registrar um módulo aqui NÃO concede acesso:
// a visibilidade usa as permissões efetivas do usuário (can) e o backend protege as rotas.
import {
  Users, Stethoscope, FileText, Package, DollarSign, BarChart3, Settings,
  LayoutDashboard, Kanban, List, Map, ClipboardList, Activity, Building2, MapPin,
  PackageCheck, FolderArchive, BedDouble, Barcode, Briefcase, Bot, Shield, Lock, Pill, Boxes, Truck,
} from 'lucide-react';
import { ROUTE_PERMS } from './routePermissions';

export const NAV_CATEGORIES = [
  { id: 'pacientes', label: 'Gestão de Pacientes', icon: Users, order: 1 },
  { id: 'assistencial', label: 'Gestão Assistencial', icon: Stethoscope, order: 2 },
  { id: 'documental', label: 'Gestão Documental', icon: FileText, order: 3 },
  { id: 'operacional', label: 'Gestão Operacional', icon: Package, order: 4 },
  { id: 'financeiro', label: 'Financeiro e Faturamento', icon: DollarSign, order: 5 },
  { id: 'indicadores', label: 'Painel & Indicadores', icon: BarChart3, order: 6 },
  { id: 'administracao', label: 'Administração', icon: Settings, order: 7 },
];

// perms: array "any-of" (vazio = qualquer usuário autenticado). masterOnly: exclusivo de master_admin.
// badge: selo visual opcional. disponivel: false oculta o módulo sem removê-lo do registro.
export const NAV_MODULES = [
  { id: 'pacientes', label: 'Cadastro de Pacientes', category: 'pacientes', icon: Users, href: '/pacientes', order: 1, activePrefix: '/pacientes' },
  { id: 'internacoes', label: 'Internações', category: 'pacientes', icon: List, href: '/lista', order: 2, activePrefix: '/lista' },
  { id: 'kanban', label: 'Kanban', category: 'pacientes', icon: Kanban, href: '/kanban', order: 3 },
  { id: 'mapa', label: 'Mapa de Pacientes', category: 'pacientes', icon: Map, href: '/mapa', order: 4 },
  { id: 'auditoria-prontuarios', label: 'Auditoria de Prontuários', category: 'pacientes', icon: Shield, href: '/auditoria-prontuarios', order: 5 },

  { id: 'especialidades', label: 'Especialidades', category: 'assistencial', icon: Activity, href: '/fisioterapia', order: 1 },
  { id: 'primeiras-avaliacoes', label: 'Primeiras Avaliações', category: 'assistencial', icon: Stethoscope, href: '/primeiros-atendimentos', order: 2 },
  { id: 'prescricao', label: 'Prescrição', category: 'assistencial', icon: Pill, href: '/prescricao', order: 3 },
  { id: 'tarefas', label: 'Tarefas de Enfermagem', category: 'assistencial', icon: ClipboardList, href: '/tarefas', order: 4 },
  { id: 'medicina-direta', label: 'Medicina Direta', category: 'assistencial', icon: Building2, href: '/medicina-direta', order: 5, badge: 'EMR' },

  { id: 'guias', label: 'Controle de Guias', category: 'documental', icon: FileText, href: '/guias', order: 1 },
  { id: 'recebimento-guias', label: 'Recebimento de Guias', category: 'documental', icon: PackageCheck, href: '/recebimento-guias', order: 2 },
  { id: 'fechamento-mensal', label: 'Fechamento Mensal', category: 'documental', icon: FolderArchive, href: '/fechamento-mensal', order: 3 },

  { id: 'estoque', label: 'Estoque', category: 'operacional', icon: Package, href: '/estoque', order: 1 },
  { id: 'sku', label: 'Controle SKU', category: 'operacional', icon: Barcode, href: '/sku', order: 2 },
  { id: 'dispensacao', label: 'Dispensação', category: 'operacional', icon: Boxes, href: '/dispensacao', order: 3 },
  { id: 'aprovisionamento', label: 'Aprovisionamento', category: 'operacional', icon: Truck, href: '/aprovisionamento', order: 4 },
  { id: 'comodato', label: 'Comodato', category: 'operacional', icon: BedDouble, href: '/comodato', order: 5 },
  { id: 'visitas', label: 'Check-in de Visitas', category: 'operacional', icon: MapPin, href: '/visitas', order: 6 },

  { id: 'convenios', label: 'Gestão de Convênios', category: 'financeiro', icon: Building2, href: '/financeiro/convenios', order: 0 },
  { id: 'custos', label: 'Custos por Paciente', category: 'financeiro', icon: DollarSign, href: '/custos', order: 1 },
  { id: 'diarias', label: 'Diárias de Internação', category: 'financeiro', icon: BedDouble, href: '/diarias', order: 2 },
  { id: 'auditoria-financeira', label: 'Auditoria Financeira', category: 'financeiro', icon: Shield, href: '/auditoria-financeira', order: 3 },
  { id: 'servicos', label: 'Serviços', category: 'financeiro', icon: Briefcase, href: '/servicos', order: 4 },

  { id: 'dashboard', label: 'Dashboard', category: 'indicadores', icon: LayoutDashboard, href: '/dashboard', order: 1 },
  { id: 'relatorios', label: 'Relatórios', category: 'indicadores', icon: BarChart3, href: '/relatorios', order: 2 },
  { id: 'estatisticas', label: 'Estatísticas', category: 'indicadores', icon: Activity, href: '/estatisticas', order: 3 },
  { id: 'ia-business-intelligence', label: 'IA Business Intelligence', category: 'indicadores', icon: Bot, href: '/agente-ia', order: 4, badge: 'IA' },
  { id: 'metricas-tempo-real', label: 'Métricas em Tempo Real', category: 'indicadores', icon: Activity, href: '/metricas', order: 5, badge: 'LIVE' },

  { id: 'configuracoes', label: 'Configurações', category: 'administracao', icon: Settings, href: '/configuracoes', order: 1 },
  { id: 'admin-seguranca', label: 'Admin de Segurança', category: 'administracao', icon: Shield, href: '/admin-seguranca', order: 2, masterOnly: true },
  { id: 'minha-conta', label: 'Minha Conta', category: 'administracao', icon: Lock, href: '/alterar-senha', order: 3 },
];

const allowed = (mod, can, user) => {
  if (mod.disponivel === false) return false;
  if (mod.masterOnly) return (user?.perfil || '').toLowerCase() === 'master_admin';
  const perms = ROUTE_PERMS[mod.href];
  return !perms || perms.length === 0 || can(...perms);
};

// Categorias visíveis com seus módulos autorizados; categorias vazias são omitidas.
export const visibleNavigation = (can, user, search = '') => {
  const q = search.trim().toLowerCase();
  return [...NAV_CATEGORIES]
    .sort((a, b) => a.order - b.order)
    .map((cat) => ({
      ...cat,
      items: NAV_MODULES
        .filter((m) => m.category === cat.id && allowed(m, can, user))
        .filter((m) => !q || m.label.toLowerCase().includes(q) || cat.label.toLowerCase().includes(q))
        .sort((a, b) => a.order - b.order),
    }))
    .filter((cat) => cat.items.length > 0);
};

export const isModuleActive = (mod, pathname) =>
  pathname === mod.href || (mod.activePrefix ? pathname.startsWith(mod.activePrefix) : false);
